import { format } from 'date-fns'

export const exploitsDatetime = datetime => {
  // One of request to handle an inacurate datetime value
  if (datetime === '2017-02-15') {
    return 'mid-Feb 2017'
  } else {
    return datetime
  }
}



// WEBPACK FOOTER //
// ./src/transforms/transforms.js